
import GwContentTemplate from '~/patterns/templates/content.vue';
import getTrainers from '~/graphql/queries/getTrainers.graphql';
import seo from '~/mixins/seo';
import getTrainersPage from '~/graphql/queries/getTrainersPage.graphql';
import GwPageTitle from '~/patterns/molecules/page-title/page-title';
import GwPageContainer from '~/patterns/molecules/page-container/page-container';
import FlexibleSection from '~/patterns/organisms/_flexible-section/flexible-section';
import GwPageIntro from '~/patterns/molecules/page-intro/page-intro';
import GwTrainerList from '~/patterns/organisms/trainer-list/trainer-list';

export default {
    components: {
        GwContentTemplate,
        GwPageContainer,
        GwPageTitle,
        GwPageIntro,
        FlexibleSection,
        GwTrainerList,
    },
    mixins: [seo],
    layout: 'overview',
    data() {
        return {
            entry: null,
            trainers: null,
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getTrainersPage,
                { site, uri }
            );

        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }

        const trainers = await this.$gql.executeQuery(
            getTrainers,
            { site }
        );

        this.trainers = trainers.data.entries;
    },
    nuxtI18n: {
        paths: {
            en: '/trainers',
            in: '/trainers',
            nl: '/trainers',
            fr: '/formateurs',
            de: '/trainer',
            'en-Highberg': '/trainers',
            'nl-Highberg': '/trainers',
            'de-Highberg': '/trainer',
        }
    }
};
